import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useStickyState } from './useStickyState'

type TStickyStateContext = {
  isStuck: boolean
  setElementId: (elementId: Nullable<string>) => void
}

const [Provider, useStickyStateCtx] = createContext<TStickyStateContext>(`StickyState`)

type TProps = RequiredChildren

/**
 * observes the position of sticky element
 * and provides the information if it's currently in stuck state
 */
export const StickyStateProvider: React.FC<TProps> = ({ children }) => {
  const [elementId, setElementId] = React.useState<Nullable<string>>(null)

  const isStuck = useStickyState(elementId)

  return <Provider value={{ isStuck, setElementId }}>{children}</Provider>
}

export { useStickyStateCtx }
